export default (props) =>
    <svg xmlns="http://www.w3.org/2000/svg" width="26.892" height="26.294" viewBox="0 0 24.522 23.965" {...props}>
        <g id="Group_chain" data-name="Group_chain" transform="translate(0.509 0.5)">
            {/* First link */}
            <rect id="link-1" data-name="link-1" x="2" y="8" width="5" height="7" rx="2.5" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="1" />
            {/* Second link */}
            <rect id="link-2" data-name="link-2" x="8.5" y="8" width="5" height="7" rx="2.5" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="1" />
            {/* Third link */}
            <rect id="link-3" data-name="link-3" x="15" y="8" width="5" height="7" rx="2.5" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="1" />
            {/* Connecting line 1 */}
            <line id="connector-1" data-name="connector-1" x1="7" y1="11.5" x2="8.5" y2="11.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1" />
            {/* Connecting line 2 */}
            <line id="connector-2" data-name="connector-2" x1="13.5" y1="11.5" x2="15" y2="11.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1" />
        </g>
    </svg>
